import {
	GraphQLEnumType,
	GraphQLInputObjectType,
	GraphQLNonNull,
	GraphQLObjectType,
	GraphQLString,
} from 'graphql';

import { TypeNames } from '../../types';

export const PrivacyValueInput = new GraphQLEnumType({
	name: TypeNames.PRIVACY_VALUE_INPUT,
	values: {
		PUBLIC: { value: 'public' },
		COLLABORATOR: { value: 'collaborator' },
		PRIVATE: { value: 'private' },
	},
});

export const UserPrivacySettingsInput = new GraphQLInputObjectType({
	fields: {
		name: { type: GraphQLString },
		nickname: { type: GraphQLString },
		jobTitle: { type: GraphQLString },
		department: { type: GraphQLString },
		organization: { type: GraphQLString },
		location: { type: GraphQLString },
		zoneinfo: { type: GraphQLString },
		email: { type: GraphQLString },
		phoneNumber: { type: GraphQLString },
		picture: { type: GraphQLString },
		teamType: { type: GraphQLString },
	},
	name: TypeNames.PRIVACY_SETTINGS_INPUT,
	description: 'User privacy settings values to be set',
});

const DefaultPrivacyValue = new GraphQLEnumType({
	name: TypeNames.PRIVACY_VALUE,
	values: {
		PUBLIC: { value: 'PUBLIC' },
		COLLABORATOR: { value: 'COLLABORATOR' },
		PRIVATE: { value: 'PRIVATE' },
	},
});

export const PrivacyValue = new GraphQLNonNull(DefaultPrivacyValue);

const UserManagePrivacySettings = new GraphQLObjectType({
	fields: {
		id: { type: new GraphQLNonNull(GraphQLString) },
		name: { type: PrivacyValue },
		nickname: { type: PrivacyValue },
		jobTitle: { type: PrivacyValue },
		department: { type: PrivacyValue },
		organization: { type: PrivacyValue },
		location: { type: PrivacyValue },
		zoneinfo: { type: PrivacyValue },
		email: { type: PrivacyValue },
		phoneNumber: { type: DefaultPrivacyValue },
		picture: { type: PrivacyValue },
		teamType: { type: PrivacyValue },
	},
	name: TypeNames.PRIVACY_SETTINGS,
	description: 'User privacy settings values',
});

export default UserManagePrivacySettings;
